import {
  fromJS
} from 'immutable';

import {
  ANY_ERROR, CLEAR_ERROR
} from '../action/user_action_types';

const INITIAL_STTATE = fromJS({
  error: null
});

export default function (state = INITIAL_STTATE, action) {
  switch (action.type) {

    case ANY_ERROR: {
      return state.set('error', action.payload);
    }

    case CLEAR_ERROR: {
      return state.set('error', null);
    }

  }
  return state;
}


// WEBPACK FOOTER //
// ./web/reducer/user_error.js